const compare = (a, b) => {
  const nameA = a;
  const nameB = b;

  let comparison = 0;
  if (nameA > nameB) {
    comparison = 1;
  } else if (nameA < nameB) {
    comparison = -1;
  }
  return comparison;
};

export const districts = [
  "Bhojpur",
  "Dhankuta",
  "Ilam",
  "Jhapa",
  "Khotang",
  "Morang",
  "Okhaldhunga",
  "Panchthar",
  "Sankhuwasabha",
  "Solukhumbu",
  "Sunsari",
  "Taplejung",
  "Terhathum",
  "Udayapur",
  "Bara",
  "Parsa",
  "Dhanusha",
  "Mahottari",
  "Rautahat",
  "Saptari",
  "Sarlahi",
  "Siraha",
  "Bhaktapur",
  "Chitwan",
  "Dhading",
  "Dolakha",
  "Kathmandu",
  "Kavrepalanchok",
  "Lalitpur",
  "Makwanpur",
  "Nuwakot",
  "Ramechhap",
  "Rasuwa",
  "Sindhuli",
  "Sindhupalchok",
  "Baglung",
  "Gorkha",
  "Kaski",
  "Lamjung",
  "Manang",
  "Mustang",
  "Myagdi",
  "Nawalpur",
  "Parbat",
  "Syangja",
  "Tanahun",
  "Arghakhanchi",
  "Banke",
  "Bardiya",
  "Dang",
  "Eastern Rukum",
  "Gulmi",
  "Kapilavastu",
  "Parasi",
  "Palpa",
  "Pyuthan",
  "Rolpa",
  "Rupandehi",
  "Dailekh",
  "Dolpa",
  "Humla",
  "Jajarkot",
  "Jumla",
  "Kalikot",
  "Mugu",
  "Salyan",
  "Surkhet",
  "Western Rukum",
  "Achham",
  "Baitadi",
  "Bajhang",
  "Bajura",
  "Dadeldhura",
  "Darchula",
  "Doti",
  "Kailali",
  "Kanchanpur",
].sort(compare);

export const provinces = [
  "Province No.1",
  "Province No.2",
  "Bagmati Province",
  "Gandaki Province",
  "Lumbini Province",
  "Karnali Province",
  "Sudurpashchim Province",
];
